import React, { useEffect } from "react";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import AboutComponent from "../../components/Home/About/About";
import Hero from "../../components/About/hero/Hero";
import Mission from "../../components/About/mission/Mission";
import WithUs from "../../components/About/withus/Withus";
import Testimonials from "../../components/Home/Testimonials/Testimonials";
import { GuideBottom } from "../../components/Home/Guide/Guide";
import Team from "../../components/About/team/Team";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <>
      <Header />
      <Hero heading="About Us" />
      <AboutComponent />
      <Mission />
      <WithUs />
      <Testimonials />
      <Team />
      <GuideBottom />
      <Footer />
    </>
  );
}

export default About;
